// Slides of the projects carousel. `image` is the screenshot, `imageLazy` a tiny
// blurred version shown while it loads.

export const projects = [
    {
        title: 'Meridius',
        role: 'Full-stack developer',
        stack: 'Gsap - Threejs',
        description:
            'Meridius is an application development company that can provide you with customized and feature-rich applications to help you boost your productivity.',
        url: 'https://meridius.io',
        image: '/img/meridius.jpg',
        imageLazy: '/img/meridius-lazy.jpg',
        logo: '/img/meridius-logo.png',
    },
    {
        title: 'Qualitext',
        role: 'Natural Language Processing developer - Web Scraping',
        stack: 'Word2Vec - Doc2Vec - NLTK - Gensim - Numpy',
        description:
            'Qualitext is an online plagiarism detection software that allows you to control and guarantee the uniqueness of your writings (articles, web content, books, internship reports, end-of-study dissertations, etc.)',
        url: 'https://qualitext.fr',
        image: '/img/qualitext.jpg',
        imageLazy: '/img/qualitext-lazy.jpg',
        logo: '/img/qualitext-logo.png',
    },
    {
        title: 'Stock Markets',
        role: 'Project Manager - Full-stack developer - Maintainer',
        stack: 'WebGL - Numpy - Numjs - Socket - VueJS - Laravel',
        description:
            'The project involves the development of personalized trading platform or market tools, which are equipped with several indicators and technical tools, some specific features such as "copy trading" and an all-in-one back office to manage customers. An overview of those software is available at:',
        url: 'http://trading.meridius.io',
        image: '/img/trading.jpg',
        imageLazy: '/img/trading-lazy.jpg',
        logo: '/img/trading-logo.png',
    },
    {
        title: 'Cétasavoir',
        role: 'Front-end developer',
        stack: 'Laravel - VueJS',
        description:
            'Cétasavoir is an online training platform for responsible observation of marine megafauna. The software is implemented with a custom content creation tool, an user management interface and an automated digital certificate delivery system',
        url: 'https://www.cetasavoir.org/',
        image: '/img/cetasavoir.jpg',
        imageLazy: '/img/cetasavoir-lazy.jpg',
        logo: '/img/cetasavoir-logo.png',
    },
    {
        title: 'Waveart',
        role: 'Front-end developer',
        stack: '',
        description:
            'Wave.art is part of a multi-cultural and international ecosystem of creatives and agencies specializing in digital, design, animation and new technologies.',
        url: 'https://www.wave.art/',
        image: '/img/waveart.jpg',
        imageLazy: '/img/waveart-lazy.jpg',
        logo: '/img/waveart-logo.png',
    },
    {
        title: 'Gametraq',
        role: 'AI developer',
        stack: 'Open ComputerVision, Torch, Tensorflow, Numpy, Multithreaded Python',
        description:
            'Gamecam, a sport-focused company, delivers cutting-edge solutions for capturing and processing vital data in the dynamic realm of sports.',
        url: 'https://www.gamecam.se/',
        image: '/img/gametraq.jpg',
        imageLazy: '/img/gametraq-lazy.jpg',
        logo: '/img/gamecam-logo.png',
    },
    {
        title: 'ResumeGPT',
        role: 'Chrome Extension Lead Developer',
        stack: 'VanillaJS, CSS, Indicative, Airtable, Chrome Extension Manifest V3',
        description:
            'RESUMEGPT is your comprehensive solution for job hunting and personal career development. "The ultimate career advancement tool"',
        url: 'https://resume-example.com/builder',
        image: '/img/resumegpt.jpg',
        imageLazy: '/img/resumegpt-lazy.jpg',
        logo: '/img/resumedone-logo.png',
    },
];
